import { Alert } from "@/shared";

export function UsersAlert() {
  const messages = [
    "* 한번 등록한 장소 정보의 주소는 수정이 불가능합니다.",
    "* 이미지 편집 시 실시간으로 처리됩니다. 삭제에 주의하세요.",
  ];
  return (
    <>
      <Alert messages={messages} />
    </>
  );
}
